// Presentation helpers only: applicability and completeness remain server decisions.
export function publishedRevision(revisions) {
  return [...revisions].filter(r => r.state === 'published').sort((a, b) => Number(b.id) - Number(a.id))[0] || null;
}
export function validScope(profile, refs, companies) {
  return companies.some(c => String(c.id) === String(profile.company_id)) && !!profile.profiles?.length && profile.profiles.every(p => {
    const group = refs.choices?.group?.find(g => g.id === p.group);
    return group?.data.roles?.includes(p.role) && !!p.site_id?.trim();
  });
}
export function itemGroups(items = [], refs = {}) {
  const groups = new Map();
  for (const item of items) {
    const context = item.context || {};
    const process = refs.choices?.process?.find(p => p.id === context.process)?.title || context.process || 'Общие требования';
    const title = [process, context.site_id].filter(Boolean).join(' · ');
    if (!groups.has(title)) groups.set(title, []);
    groups.get(title).push(item);
  }
  return [...groups.entries()];
}
export function requirementTitle(item) {
  return item.requirement?.title || item.requirement?.requirement || item.requirement_id || 'Проверка';
}
